import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PsButtonTuner } from 'stencilSetup';
import { useDownloadConfirmationQuery } from 'theSource/queries/useDownloadConfirmationQuery/useDownloadConfirmationQuery';
import { getPlanYearLookupCodeFromOrgPlanYear } from './utils';
import { useConfigurationQuery } from 'theSource/queries';
import { queryClient } from '../../theSource/utils';
import { GET_DOWNLOAD_CONFIRMATION_QUERY_KEY } from '../../theSource/queries/useDownloadConfirmationQuery/utils';

interface DownloadConfirmationProps {
  enrollmentContext?: string;
  planYearStartsOn: Date;
  planYearEndsOn: Date;
}

export const DownloadConfirmation = ({
  enrollmentContext,
  planYearStartsOn,
  planYearEndsOn,
}: DownloadConfirmationProps) => {
  const { configuration } = useConfigurationQuery();
  const lumosApiHost = configuration?.apiHost;

  const { t } = useTranslation();

  const [enabled, setEnabled] = useState(false);
  const orgPlanYearCode = getPlanYearLookupCodeFromOrgPlanYear(
    planYearStartsOn,
    planYearEndsOn
  );

  const { isLoadingDownloadConfirmation } = useDownloadConfirmationQuery({
    enabled: enabled && Boolean(orgPlanYearCode),
    lumosApiHost: lumosApiHost,
    enrollmentType: enrollmentContext,
    orgPlanYearCode: orgPlanYearCode || '',
    lifeEventCompleted: false,
    onSuccessFn() {
      setEnabled(false);
    },
    onErrorFn() {
      setEnabled(false);
    },
  });

  useEffect(() => {
    if (enabled) {
      queryClient.invalidateQueries(
        `${GET_DOWNLOAD_CONFIRMATION_QUERY_KEY}_${orgPlanYearCode}`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  return (
    <PsButtonTuner
      buttonId="download-statement"
      data-testid="download-statement"
      level="tertiary"
      label={t('common:download')}
      icon-right="download-simple"
      onClick={() => setEnabled(true)}
      disabled={isLoadingDownloadConfirmation}
    />
  );
};
